import { http } from 'http';
import { createPaginationQuery } from 'helpers/store';
import { getQueryFilters } from 'utils/filters';

export default {
  fetch: () => http.get('/catalog/partners'),

  campaignsByPartnerIdFromCatalog: ({ partnerId, pagination, filters }) =>
    http.get(`/catalog/${partnerId}${createPaginationQuery(pagination)}${getQueryFilters(filters)}`)
};
